<template>
    <div>
        <div v-if="options_loaded && passed_filter">
            <div class="designeroption" data-designer-component-id="{{component_id}}">
                <h3>{{ title }} </h3>
                <div class="stylesoption designer-question-tiled-layout" v-if="!loading">
                    <div class="tile" @click.prevent="localTarget = option.value"
                         :class="[localTarget == option.value ? 'active' : '']" v-for="option in filtered_option_list">
                        <a href="#">
                            <designer-thumbnail :label="option.label" :thumb_path="getThumbUrlFor(option.value)" :fabricator="fabricator"></designer-thumbnail>
                            <label>{{ option.label }}</label>
                            <i class="fa fa-check" aria-hidden="true"></i>
                        </a>
                    </div>
                    <!--flexbox hack-->
                    <div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div>
                </div>
                <div v-if="loading">
                    <p>Loading Options</p>
                </div>
                <div v-if="isMidrail" class="stylesoption">
                    <span class="txt-sm">Midrail height will match your door, style dependant / fixed at 900mm.</span>
                </div>
            </div>
        </div>
        <div v-if="limits" :class="['designeroption', measurement === undefined || measurement > to_limit || measurement < from_limit ? 'has-error' : 'has-success']" v-show="technical_should_show">
            <div class="stylesoption">
                <label :for="component_id + '_' + measurementKey">{{ measurementLabel }} ({{ from_limit }}mm to {{ to_limit }}mm)</label>
                <div class="form-group">
                    <input :id="component_id + '_' + measurementKey" type="number" v-model="measurement" class="form-control"
                           number>
                    <span id="helpBlock" class="txt-sm">{{ hasIntegratedSide ? 'This size includes any addons you choose' : 'This size includes 10mm coupler and any addons you choose' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameSidePanel from "../DesignerQuestionSelectFrameSidePanel.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameSidePanel,
        ],
        computed: {
            isMidrail() {
                return this.localTarget === 4 ||
                        this.localTarget === 5 ||
                        this.localTarget === 6 ||
                        this.localTarget === 7 ||
                        this.localTarget === 10 ||
                        this.localTarget === 12 ||
                        this.localTarget === 13 ||
                        this.localTarget === 18 ||
                        this.localTarget === 19 ||
                        this.localTarget === 20 ||
                        this.localTarget === 21 ||
                        this.localTarget === 22 ||
                        this.localTarget === 23 ||
                        this.localTarget === 24 ||
                        this.localTarget === 25 ||
                        this.localTarget === 27 ||
                        this.localTarget === 28;
            },
            hasIntegratedSide() {
                return this.frameStyleId === 15 ||
                        this.frameStyleId === 17 ||
                        this.frameStyleId === 19 ||
                        this.frameStyleId === 21 ||
                        this.frameStyleId === 22 ||
                        this.frameStyleId === 27 ||
                        this.frameStyleId === 29 ||
                        this.frameStyleId === 30;
            },
        },
        methods: {
            getThumbUrlFor(value){
                return this.thumbURL + value;
            },
        },
    }
</script>
